<template>
    <div v-if="errors" class="alert alert-danger" role="alert">
        {{ errors }}
    </div>
</template>
<script>
export default {
    name: 'FormError',
    props: ['errors'],
}

</script>
